import {
    DialogClose,
} from '@/components/ui/dialog';
import { BaseModal } from '@/shared/ui/BaseModal.jsx';
import { Button } from '@/components/ui/button';
import { useDeleteRequest } from '@/shared/hooks/requests.js';
import { FILE } from '@/shared/utils/urls.js';
import { toast } from 'sonner';
import { toastApiError } from '@/shared/utils/apiError.js';
import LoadingSpinner from '@/shared/ui/LoadingSpinner.jsx';
import { useTranslation } from 'react-i18next';

// Moves a file to the trash (DELETE /embed/v1/file/{file_uuid}). A signed
// document is refused (`signed_must_archive`): it is archived instead.
export const DeleteFile = ({ open, onOpenChange, file, setData }) => {
    const { t } = useTranslation();
    // The handler toasts with per-code text — no hook toast on top.
    const deleteFile = useDeleteRequest({ showError: false });

    const handleDelete = async () => {
        if (!file?.uuid) return;
        const { success, error } = await deleteFile.request({ url: FILE.replace('{file_uuid}', file.uuid) });
        if (success) {
            toast.success(t('my-docs:deleteFile.success'));
            onOpenChange(false);
            setData();
        } else {
            // Structured envelope: {detail: {code, ...}} — map the codes the
            // delete endpoint actually raises.
            toastApiError(error, {
                signed_must_archive: t('my-docs:deleteFile.blockedBySignature'),
                owner_only_delete: t('my-docs:deleteFile.permissionDenied'),
            });
        }
    };

    return (
        <BaseModal
            open={open}
            onOpenChange={onOpenChange}
            title={t('my-docs:deleteFile.title')}
            footer={
                <div className="flex justify-end gap-3">
                    <DialogClose asChild>
                        <Button variant="ghost">{t('my-docs:btn.cancel')}</Button>
                    </DialogClose>
                    <Button variant="destructive" onClick={() => handleDelete()} disabled={deleteFile.loading}>
                        {deleteFile.loading ? <LoadingSpinner color="#fff" /> : t('my-docs:btn.delete')}
                    </Button>
                </div>
            }
        >
            <p className="text-sm text-gray-600">
                {t('my-docs:deleteFile.description')} <b>{file?.name}</b>?
            </p>
        </BaseModal >
    );
};
